const SVG_CLASS = 'category-icon__svg';
export function buildCategoryIconSvgHtml(asset, className = SVG_CLASS, size = '100%') {
    return `<svg class="${className}" viewBox="${asset.viewBox}" width="${size}" height="${size}" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${asset.markup}</svg>`;
}
export function buildCategoryIconProgrammaticSvgHtml(innerMarkup, className = SVG_CLASS, size = '100%') {
    if (!innerMarkup)
        return '';
    return `<svg class="${className}" viewBox="0 0 24 24" width="${size}" height="${size}" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">${innerMarkup}</svg>`;
}
const SHAPE_TAGS = new Set(['path', 'circle', 'ellipse', 'rect', 'polygon', 'polyline']);
export function parseCategoryIconSvgAsset(raw) {
    const viewBoxMatch = raw.match(/viewBox="([^"]+)"/i);
    const viewBox = viewBoxMatch?.[1] || '0 0 48 48';
    let inner = raw
        .replace(/<\?xml[\s\S]*?\?>/gi, '')
        .replace(/<!--[\s\S]*?-->/g, '')
        .replace(/<style[\s\S]*?<\/style>/gi, '')
        .replace(/<svg[^>]*>/i, '')
        .replace(/<\/svg>\s*$/i, '')
        .trim();
    inner = inner.replace(/<([a-zA-Z][\w:-]*)([^>]*)(\/?)>/g, (_match, tag, attrs, selfClose) => {
        if (!SHAPE_TAGS.has(tag.toLowerCase())) {
            return `<${tag}${attrs}${selfClose}>`;
        }
        const nextAttrs = attrs
            .replace(/\sclass="[^"]*"/gi, '')
            .replace(/\sfill="[^"]*"/gi, '')
            .replace(/\sstroke="[^"]*"/gi, '');
        return `<${tag}${nextAttrs} fill="currentColor"${selfClose}>`;
    });
    return { viewBox, markup: inner };
}
